import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import type { ITransportObjectInfo } from "../../../models/storeModels/ITransportObjectInfo";


const initialState: ITransportObjectInfo = {
    transportObjectInfoStateNumber: undefined
}

export const transportObjectInfoSlice = createSlice({
    name: 'transportObjectInfo',
    initialState,
    reducers: {
        setTransportObjectInfoStateNumber(state, action: PayloadAction<any>) {
            state.transportObjectInfoStateNumber = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const {
    setTransportObjectInfoStateNumber
} = transportObjectInfoSlice.actions
export const transportObjectInfoReducer = transportObjectInfoSlice.reducer;
